module.exports = __webpack_public_path__ + "img/slide-7.ebbe72d6.jpeg";